import useSWR from "swr";

import { getConversationReport } from "@/api/conversation";
import SWR_KEYS from "@/constants/swr-keys";
import { ConversationReportQuery, IConversationReportRow } from "@/types/conversation-report.types";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

type Props = RequestPagination & {
  query: ConversationReportQuery;
};

type SwrKey = [string, number, number, string];

const useGetConversationReport = ({
  pageNumber,
  pageSize,
  query,
}: Props): RequestsBaseReturn<PaginatedResponse<IConversationReportRow> | null> => {
  const queryKey = JSON.stringify(query);
  const { data = null, isValidating: isLoading, error } = useSWR<
    PaginatedResponse<IConversationReportRow>,
    Error,
    SwrKey
  >(
    [SWR_KEYS.getConversationReport, pageNumber, pageSize, queryKey],
    ([, currentPage, currentSize]) =>
      getConversationReport(query, { pageNumber: currentPage, pageSize: currentSize }),
    { revalidateOnFocus: false, shouldRetryOnError: false }
  );

  return { data, isLoading, error };
};

export default useGetConversationReport;
